const EyeIcon = ({ className }) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9168 15.75C10.8457 15.75 9.16676 14.0711 9.16676 12C9.16676 9.92893 10.8457 8.25 12.9168 8.25C14.9878 8.25 16.6668 9.92893 16.6668 12C16.6668 14.0711 14.9878 15.75 12.9168 15.75ZM10.6668 12C10.6668 13.2426 11.6741 14.25 12.9168 14.25C14.1594 14.25 15.1668 13.2426 15.1668 12C15.1668 10.7574 14.1594 9.75 12.9168 9.75C11.6741 9.75 10.6668 10.7574 10.6668 12Z"
        fill="#6C6C72"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.43707 6.71298C8.14271 5.38141 10.3462 4.25 12.9168 4.25C15.4873 4.25 17.6908 5.38141 19.3965 6.71298C21.1036 8.04576 22.3655 9.61974 23.0714 10.6095L23.1246 10.6837C23.3777 11.0358 23.6668 11.4378 23.6668 12C23.6668 12.5622 23.3777 12.9642 23.1246 13.3163L23.0714 13.3905C22.3655 14.3803 21.1036 15.9542 19.3965 17.287C17.6908 18.6186 15.4873 19.75 12.9168 19.75C10.3462 19.75 8.14271 18.6186 6.43707 17.287C4.72989 15.9542 3.46803 14.3803 2.76217 13.3905L2.70895 13.3163C2.4558 12.9642 2.16676 12.5622 2.16676 12C2.16676 11.4378 2.4558 11.0358 2.70895 10.6837L2.76217 10.6095C3.46803 9.61974 4.72989 8.04576 6.43707 6.71298ZM7.36012 7.89534C5.80914 9.10618 4.64363 10.5547 3.98343 11.4805C3.82011 11.7095 3.74238 11.8213 3.69604 11.9103C3.66659 11.9669 3.66667 11.9824 3.66675 11.9976L3.66676 12L3.66675 12.0024C3.66667 12.0176 3.66659 12.0331 3.69604 12.0897C3.74238 12.1787 3.82011 12.2905 3.98343 12.5195C4.64364 13.4453 5.80914 14.8938 7.36012 16.1047C8.91264 17.3167 10.7981 18.25 12.9168 18.25C15.0354 18.25 16.9209 17.3167 18.4734 16.1047C20.0244 14.8938 21.1899 13.4453 21.8501 12.5195C22.0134 12.2905 22.0911 12.1787 22.1375 12.0897C22.1669 12.0331 22.1669 12.0176 22.1668 12.0024L22.1668 12L22.1668 11.9976C22.1669 11.9824 22.1669 11.9669 22.1375 11.9103C22.0911 11.8213 22.0134 11.7095 21.8501 11.4804C21.1899 10.5547 20.0244 9.10618 18.4734 7.89534C16.9209 6.68331 15.0354 5.75 12.9168 5.75C10.7981 5.75 8.91264 6.68331 7.36012 7.89534Z"
        fill="#6C6C72"
      />
    </svg>
  );
};

export default EyeIcon;
